import request from 'services/axios';

export function httpGetUsers(params) {
  return request.get('/api/users/', { params });
}

export function httpGetPartiallyUsers(params) {
  return request.get('api/users/options', { params });
}

export function httpGetUser(id) {
  return request.get(`/api/users/${id}/`);
}

export function httpGetMe() {
  return request.get('/api/users/me');
}

export function httpPostUser(dto) {
  return request.post('/api/users/', dto);
}

export function httpPutUser(dto) {
  return request.put(`api/users/${dto.id}/`, dto);
}

// export function httpPutUser(dto) {
//   return request({ method: 'PATCH', data: dto, url: 'api/users/' });
// }

export function httpPatchUserRole(id, role) {
  return request.patch(`/api/users/${id}/`, { role });
}

export function httpDeleteUser(id) {
  return request.delete(`/api/users/${id}/`);
}
